/* KREENUTS: 140g quantity tiles in quick-view, which is fetched after page load.
   The normal buy-buttons block script may not be loaded on a collection page. */
(() => {
  if (window.__kreenutsQuickViewTiersInstalled) return;
  window.__kreenutsQuickViewTiersInstalled = true;

  document.addEventListener('click', (event) => {
    const origin = event.target;
    if (!(origin instanceof Element)) return;
    const tier = origin.closest('#quick-add-dialog [data-kreenuts-volume-tier]');
    if (!(tier instanceof HTMLButtonElement) || tier.disabled) return;
    const deal = tier.closest('[data-kreenuts-volume-deal]');
    const form = tier.closest('form');
    if (!deal || !form || !tier.dataset.variantId) return;

    const input = form.querySelector('input[name="id"]');
    if (!(input instanceof HTMLInputElement)) return;

    for (const item of deal.querySelectorAll('[data-kreenuts-volume-tier]')) {
      const selected = item === tier;
      item.classList.toggle('is-active', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    }

    // The product-form component reads this input when "Add to cart" is pressed.
    input.value = tier.dataset.variantId;

    const quantity = form.querySelector('input[name="quantity"]');
    if (quantity instanceof HTMLInputElement && tier.dataset.quantity) {
      quantity.value = tier.dataset.quantity;
    }

    const selector = form.querySelector('[data-kreenuts-subscription-selector]');
    if (!selector) return;

    const oneTime = selector.querySelector('[data-kreenuts-one-time-price]');
    const subscription = selector.querySelector('[data-kreenuts-subscription-price]');
    if (oneTime && tier.dataset.oneTimePrice) oneTime.textContent = tier.dataset.oneTimePrice;
    if (subscription && tier.dataset.subscriptionPrice) subscription.textContent = tier.dataset.subscriptionPrice;
  }, true);
})();
